// Lista real de provedores atendidos pela SAT Labs (fornecida pelo cliente).
// Nomes são razão social completa — muitos são longos demais pra caber num
// card, então derivamos uma sigla curta automaticamente (ver deriveShort)
// pra mostrar em destaque, com o nome completo como subtexto menor embaixo.
// Se alguma sigla gerada ficar ruim, dá pra sobrescrever pontualmente no
// objeto OVERRIDES abaixo, sem precisar mexer no algoritmo.

const RAW_NAMES = [
  "Plug Provedores de Internet LTDA – ME",
  "Marksat Telecomunicações Ltda (PEGANET)",
  "E2NETWORK TELECOM BRASIL LTDA( PEOPLE)",
  "Infotec Telecom Ltda",
  "Brasil Like Telecomunicações Eireli",
  "Gigalinks Telecom Internet Solution",
  "GNEX LTDA",
  "OPS TELECOM SERVIÇOS EM TELECOMUNICAÇÕES LTDA",
  "R.L. QUEIROZ DA SILVA PROVEDOR DE INTERNET",
  "MASTER DATA TELECOMUNICAÇÕES LTDA",
  "LUIZ LIMA E CIA LTDA (MASTER)",
  "OLIVEIRA SANTOS TELECOMUNICAÇÕES LTDA",
  "NETWORKDIGITAL LTDA (NETWORK INFORMÁTICA)",
  "COMPLETA TELECOMUNICAÇÕES LTDA - EiTV",
  "PERTEC SERVIÇOS DE TELECOMUNICAÇÕES LTDA",
  "MIX NET TELECOMUNICAÇÕES LTDA",
  "DÁLTONY CARLOS TAVARES CAETANO MUNHOZ",
  "A. ALVES GOMES INFORMÁTICA (TIANGUA) - EiTV",
  "RE SERVIÇOS DE COMUNICAÇÃO MULTIMIDIA LTDA",
  "ALA TELECOM LTDA - Luciene",
  "WNNET TELECOM LTDA – Luciene",
  "HIPERVI SERV DE COM. MULTIMIDIA LTDA",
  "MIKOL NET TELECOMUNICAÇÕES LTDA – Lucas",
  "LOCALNET TELECOM LTDA – Renan",
  "CEDNET PROVEDOR DE INTERNET LTDA – EiTV",
  "GIGAREDE TECNOLOGIA DA INFORMAÇÃO LTDA – Cláudio",
  "NETSIM PROVEDOR DE SISTEMA DE INTEGRAÇÃO A MIDIA",
  "LICOMFÁ ANDRADE FONTES (REDE GLOBAL) – Cláudio",
  "L.A. INFORMÁTICA LTDA",
  "VB TELECOM PSI E TELECOMUNICAÇÕES LTDA",
  "COTIA FIBER SERVIÇOS DE TELECOMUNICAÇÕES LTDA",
  "SULCATEL TELECOMUNICAÇÕES LTDA",
  "VDNET TELECOM LTDA",
  "ALGU SERVIÇOS DE VALOR ADICIONADO LTDA",
  "SPNETFIBRA PROVEDOR NETWORKING LTDA",
  "GAT TELECOM COMUNICAÇÕES EIRELLI (GRUPO A TELECOM)",
  "RLC COMERCIO E SERVIÇO LTDA (RLC TELECOM)",
  "LOG INFORMÁTICA LTDA",
  "JAIRO DE OLIVEIRA SILVA (TECNET)",
  "IVATEL REDES E INTERNET LTDA",
  "LEITE & SANTOS LTDA",
  "UNIVERSO DIGITAL TELECOMUNICAÇÕES LTDA",
  "ARI DE FREITAS CAMARGO - MULTIMIDIA",
  "MOGI FIBRA TELECOMUNICAÇÕES SLU LTDA",
  "CZNET PROVEDOR DE INTERNET LTDA",
  "PORTO NET LTDA",
  "IPSCAPE PROVEDOR DE INTERNET LTDA",
  "HELLO INTERNET LTDA",
  "ESMERALDA DE ARAÚJO DELFINO – MAXXINET",
  "FIAIS & MELO NET INFORMÁTICA LTDA (ATIVA NET)",
  "NETON COMERCIO E SERV. DE INFORMATICA (MEGAVIA)",
  "CPGNET SOLUÇÕES EM INTERNET E REDE LTDA",
  "SOF TELECOM LTDA",
  "D. COELHO BEZERRA – TURBO.COM",
  "MOBILLE TELECOM LTDA - ME",
  "FH COMERCIO E COMUNICAÇÕES SAT LTDA",
  "L.L.NET TELECOM LTDA",
  "DISKNET INTERNET BANDA LARGA LTDA",
  "3D NETWORK LTDA",
  "FIBERLAN TELECOM LTDA",
  "SLIM WEB SOLUTIONS LTDA (SPEED NET)",
  "HYCOM INTERNET INTELIGENTE LTDA",
  "M.S TELECOMUNICAÇÕES LTDA",
  "LAINER TELECOMUNICAÇÕES LTDA",
  "TELNEXT FIBER TELECOM LTDA",
  "ALLIG TELECOM LTDA",
  "GRX BRASIL TELECOM LTDA",
  "IRANET TELECOM LTDA",
  "VP DOS SANTOS PROVEDORES DE ACESSO LTDA",
  "FOX NET PROVEDOR DE ACESSO A INTERNET LTDA",
  "TERA INTERNET LTDA",
  "SAMUEL PEDRO DE GODOY SILVA (UNIWEB TELECOM)",
  "GRD TELECOMUNICAÇÕES LTDA",
  "L.E. GUIZUM BENSONI – COMUNICAÇÃO (NEOFIBRA)",
  "FASTNET TELECOM LTDA",
  "GIGANET PROVEDOR LTDA",
  "CAMPO LINK TELECOMUNICAÇÕES LTDA",
  "J.A. HELFER (HTEC SOLUÇÃO EM TECNOLOGIA)",
  "TURBO NET TELECOM SERVIÇOS E VENDAS DE EQUIPAMENTOS",
  "ALBERT FIGUEIROA CALDEIRA DA SILVA – SIMPLI-FI",
  "R. PIETSCH & CIA LTDA (NETVALE)",
  "STI TELECOM LTDA (TELECOM FOZ) - EiTV",
  "VOGLIO SOLUÇÕES EM SERVIÇOS LTDA",
  "INTERNET HOUSE TELECOM LTDA",
  "ALL CABLE SERVIÇOS DE TELECOMUNICAÇÕES LTDA",
  "CLICK NET BRASIL TELECOMUNICAÇÕES LTDA",
  "VIVENDO BEM BRASIL ASSISTENCIAS - EiTV",
  "WELLINGTON PAIVA DAMASCENA & CIA LTDA",
  "INSIDE TECHNOLOGY LTDA",
  "ELETROTERA LTDA",
  "MEGANET TELECOM LTDA",
  "ACERTLINE PROVEDOR DE INTERNET LTDA",
  "ST SOLUÇÕES EM TECNOLOGIA LTDA",
  "DAVOI ISP – PROVEDOR DE SOLUÇÕES E ACESSO A INTERNET",
  "CONNECT LP – SERVIÇO DE COMUNICAÇÃO MULTIMIDIA",
  "NEXTHOP INFORMÁTICA LTDA",
  "FIBRAWEB TELECOM COMÉRCIO E SERVIÇO",
  "STRAUSKI & GALVÃO LTDA",
  "NOVA NETWORK TELECOM LTDA",
  "AHA DE SOUSA SERVIÇO DE INTERNET LTDA (IPV6)",
  "J.S SANTOS SERVIÇOS DE COMUNICAÇÃO (IPCONECT)",
  "J.QA TELECOM E INFORMÁTICA LTDA",
  "DONINI & SALDANHA TELECOMUNICAÇÕES LTDA",
  "SOLARIUM NET TV TELECOM DE CABO FRIO LTDA",
  "INNOVA NET TELECOM LTDA",
  "FOX SERVIÇOS DE COMUNICAÇÃO MULTIMIDIA LTDA",
  "J A TELECOM LTDA",
  "GTEC SOLUÇÕES TECNOLOGICAS E COMERCIO LTDA",
  "VARZEA NET TELECOMUNICAÇÕES LTDA ME",
  "RRP TELECOM LTDA",
  "PASSPORT TECNOLOGIA LTDA",
  "NET LINK TELECOMUNICAÇÕES LTDA",
  "ASJ COMUNICAÇÃO MULTIMIDIA LTDA",
  "MAIS NET LTDA",
  "ROGÉRIO L. DOS SANTOS LTDA",
  "PROVEDOR DE INTERNET COM FIBRAS OPTICA PLAY",
  "EXPRESS NETWORK LTDA",
  "CLECIA DA LUZ SOUZA NOVAES",
  "CARDIMPLAY ENTRETENIMENTO, TECNOLOGIA E COMUNICAÇÃO",
  "LF TELECOMUNICAÇÕES DE TERESÓPOLIS LTDA",
  "FLASH TELECOM LTDA",
  "ALT INFORMÁTICA LTDA",
  "PARENTE E FERNANDES LTDA",
  "CLICK FIBRA TELECOMUNICAÇÕES LTDA",
  "G. SAT. SERVIÇOS DE COMUNICAÇÃO LTDA",
  "FORÇA E AÇÃO SERVIÇOS DE TELECOMUNICAÇÕES LTDA",
  "NOVA INTERNET LTDA",
  "MGT COMUNICAÇÃO LTDA",
  "PLAYNET TELECOMUNICAÇÕES LTDA",
  "SYNCONTEL SERVIÇOS & INTERNET LTDA",
  "REAL HOSPITAL PORTUGUES DE BENEFICENCIA",
  "TOPNET MARAJÓ LTDA",
  "NETSAT DA AMAZÔNIA LTDA",
  "NEWVELOX BOOKS E TI SERVICES LTDA",
  "NET ONZE SERVIÇOS DE DATACENTERS E COBRANÇAS",
  "SAN-SAT TELECOMUNICAÇÕES LTDA",
  "ZW PRESTAÇÃO DE SERVIÇO EM TELECOMUNICAÇÕES",
  "GV TELECOMUNICAÇÕES LTDA",
  "VUNN INTERNET FIBRA LTDA",
  "IMPERIAL NET FIBRA LTDA",
  "WR NET TELECOMUNICAÇÕES LTDA",
  "SECW TELECOM LTDA",
  "ELAINE BEATRIZ CABRAL NASCIMENTO",
  "POWERNET SOLUÇÕES INTEGRADAS",
  "ZORG – TELECOM COMÉRCIO E SERVIÇOS",
  "MEGA FIBRA INFINITY + LTDA",
  "STOCK NET SERV DE CONEX. INT E SERV. DE COM.",
  "SERRALINK SERV DE INTERNET E TECNOLOGIAS DA INFORMAÇÃO",
  "RAPIDLINK TELECOM LTDA",
  "WCA-TI TECNOLOGIA EM SISTEMA DE INFORMAÇÃO LTDA",
  "CONEXÃO RIO TELECOMUNICAÇÕES LTDA",
  "RAVI TELECOM LTDA",
  "WEBSPOT SOLUÇÕES EM INTERNET, SOFTWARE E COMUNICAÇÃO",
  "FUTURACONNECT NETWORK LTDA",
  "STAMP PROVEDOR SERVIÇOS DE COMUNICAÇÃO LTDA",
];

// Ajustes pontuais onde a primeira palavra "de verdade" ficaria ruim ou
// pouco reconhecível — chave é o texto exato de RAW_NAMES.
const OVERRIDES: Record<string, string> = {
  "3D NETWORK LTDA": "3D Network",
};

function isInitialToken(word: string) {
  // tokens tipo "R.L.", "A.", "J.QA" — abreviação de nome próprio, não dá
  // pra usar como "primeiro nome" sozinho, então pula pra próxima palavra.
  return word.length <= 4 && word.includes(".");
}

function deriveShort(rawName: string): string {
  if (OVERRIDES[rawName]) {
    return OVERRIDES[rawName];
  }

  // corta anotações que não são o nome da empresa (parênteses, e o texto
  // depois de um hífen/traço solto — normalmente nome de vendedor interno)
  let base = rawName.split("(")[0];
  base = base.split(/\s[-–]\s/)[0];
  base = base.trim();

  const words = base.split(/\s+/).filter(Boolean);
  const firstReal = words.find((w) => !isInitialToken(w)) ?? words[0] ?? base;

  // mantém números/siglas curtas como vieram (ex.: "3D", "GNEX"); só ajusta
  // capitalização de palavras normais, pra não gritar em CAIXA ALTA total.
  if (/^[A-ZÀ-Ú0-9]{2,}$/.test(firstReal) && firstReal.length <= 6) {
    return firstReal;
  }
  return firstReal.charAt(0).toUpperCase() + firstReal.slice(1).toLowerCase();
}

export type Client = { name: string; short: string };

export const clients: Client[] = RAW_NAMES.map((name) => ({
  name: name.trim(),
  short: deriveShort(name),
}));
